<template>
<zm-dialog title="Batch Create Topics" :visible.sync="visible" width="80%" class="short-dialog">
    <zm-button size="small" type="primary" plain @click="addParam" v-show="active === 0">add</zm-button>
    <zm-tabs tab-position="top" type="card" style="margin-top: 5px;" v-show="active === 0">
        <zm-tab-pane v-for="(item, index) in form.batchTopicParams" :key="index">
            <span slot="label">
                {{ form.batchTopicParams[index].name || 'New Topic' }}
                <zm-button type="icon" icon="zm-icon-delete" @click.prevent="deleteParam(index)"></zm-button>
            </span>
            <batch-create-param :ref="'batch-param-' + index" :index="index" @updateName="updateName"></batch-create-param>
            <!-- <zm-button size="small" type="icon" icon="zm-icon-delete" plain style="margin-bottom: 10px;" @click="deleteParam(index)"></zm-button> -->
        </zm-tab-pane>
    </zm-tabs>
    <!-- <batch-create-param v-for="(item, index) in form.batchTopicParams" :key="index" :ref="'batch-param-' + index"></batch-create-param> -->
    <zm-form :model="form" label-position="left" :rules="rules" ref="form" style="width: 95%;" v-show="active === 0" :label-width="formLabelWidth">
        <zm-form-item label="owner" prop="owner">
            <div slot="label">
                <tip label="owner" id="topic-batchcreate-owner"></tip>
            </div>
            <zm-input size="small" v-model.trim="form.owner"></zm-input>
        </zm-form-item>
        <zm-form-item label="description" prop="description">
            <div slot="label">
                <tip label="description" id="topic-batchcreate-description"></tip>
            </div>
            <zm-input size="small" v-model="form.description" type="textarea"
                :autosize="{ minRows: 1, maxRows: 4}"></zm-input>
        </zm-form-item>
        <zm-form-item label="channels">
            <div slot="label">
                <tip label="channels" id="topic-batchcreate-channels"></tip>
            </div>
            <zm-input-number size="small" v-model="form.channels" :min="form.minchannel"></zm-input-number>
        </zm-form-item>
        <zm-form-item label="replicaFactor">
            <div slot="label">
                <tip label="replicaFactor" id="topic-batchcreate-replicaFactor"></tip>
            </div>
            <zm-input-number size="small" v-model="form.factor" :min="1"></zm-input-number>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.ordered">
                <tip label="ordered" id="topic-batchcreate-ordered"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label="threshold">
            <div slot="label">
                <tip label="threshold" id="topic-batchcreate-threshold"></tip>
            </div>
            <zm-input-number size="small" v-model="form.threshold" :min="0"></zm-input-number>
        </zm-form-item>
        <zm-form-item label="failedRate">
            <div slot="label">
                <tip label="failedRate" id="topic-batchcreate-failedRate"></tip>
            </div>
            <div style="width: 100%">
                <zm-input-number size="small" v-model="form.failedRate"
                    :min="0" :max="100" class="number-with-select"></zm-input-number>
                <zm-tag type="info" class="tag-with-number">%</zm-tag>
            </div>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.ack">
                <tip label="ack" id="topic-batchcreate-ack"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label="" label-width="0px">
            <zm-checkbox v-model="form.timeoutIsSuccess">
                <tip label="timeoutIsSuccess" id="topic-batchcreate-timeoutIsSuccess"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.active">
                <tip label="active" id="topic-batchcreate-active"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-collapse v-model="showAdvancedFeatureMap">
            <zm-collapse-item title="additional parameters" name="2">
        <zm-form-item label="version">
            <div slot="label">
                <tip label="version" id="topic-batchcreate-version"></tip>
            </div>
            <zm-input-number size="small" v-model="form.version" :min="0"></zm-input-number>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.enableMetrics">
                <tip label="enable metrics" id="topic-batchcreate-enableMetrics"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label="clientMapRetentionDay" label-width="200px">
            <div slot="label">
                <tip label="clientMapRetentionDay" id="topic-batchcreate-clientMapRetentionDay"></tip>
            </div>
            <zm-input-number size="small" v-model="form.clientMapRetentionDay" :min="0"></zm-input-number>
        </zm-form-item>
        <zm-form-item label="consumerClientParam" label-width="180px">
            <div slot="label">
                <tip label="consumerClientParam" id="topic-batchcreate-consumerClientParam"></tip>
            </div>
            <zm-select size="small" v-model="form.consumerClientParamId" clearable filterable>
                <zm-option v-for="item in consumerClient" :key="item.id" :value="item.id" :label="item.name"></zm-option>
            </zm-select>
        </zm-form-item>
        <zm-form-item label="producerClientParam" label-width="180px">
            <div slot="label">
                <tip label="producerClientParam" id="topic-batchcreate-producerClientParam"></tip>
            </div>
            <zm-select size="small" v-model="form.producerClientParamId" clearable filterable>
                <zm-option v-for="item in producerClient" :key="item.id" :value="item.id" :label="item.name"></zm-option>
            </zm-select>
        </zm-form-item>
        <zm-form-item label="pollDurationMs" label-width="180px">
            <div slot="label">
                <tip label="pollDurationMs" id="topic-batchcreate-pollDurationMs"></tip>
            </div>
            <zm-input-number size="small" v-model="form.pollDurationMs" :min="1"></zm-input-number>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.publishIsPublic">
                <tip label="publish is public" id="topic-batchcreate-publishIsPublic"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.subscribeIsPublic">
                <tip label="subscribe is public" id="topic-batchcreate-subscribeIsPublic"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.discardUnhandledTask">
                <tip label="discardUnhandledTask" id="topic-batchcreate-discardUnhandledTask"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.disableFailover">
                <tip label="disableFailover" id="topic-batchcreate-disableFailover"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label="maxProduceRetryTimes" label-width="200px">
            <div slot="label">
                <tip label="maxProduceRetryTimes" id="topic-batchcreate-maxProduceRetryTimes"></tip>
            </div>
            <zm-input-number size="small" v-model="form.maxProduceRetryTimes" :min="0"></zm-input-number>
        </zm-form-item>
        <zm-form-item label="produceRetryInterval" label-width="200px">
            <div slot="label">
                <tip label="produceRetryInterval" id="topic-batchcreate-produceRetryInterval"></tip>
            </div>
            <div style="width: 100%">
                <zm-input-number size="small" v-model="form.produceRetryInterval"
                    :min="0" class="number-with-select"></zm-input-number>
                <zm-select size="small" v-model="form.produceRetryIntervalTimeUnit" class="select-with-number">
                    <zm-option value="SECONDS">SECONDS</zm-option>
                    <zm-option value="MINUTES">MINUTES</zm-option>
                    <zm-option value="HOURS">HOURS</zm-option>
                    <zm-option value="DAYS">DAYS</zm-option>
                </zm-select>
            </div>
        </zm-form-item>
        <zm-form-item label="produceLimit">
            <div slot="label">
                <tip label="produceLimit" id="topic-batchcreate-produceLimit"></tip>
            </div>
            <zm-input-number size="small" v-model="form.produceLimit" :min="0"></zm-input-number>
        </zm-form-item>
        <zm-form-item label="produceJobLimit">
            <div slot="label">
                <tip label="produceJobLimit" id="topic-batchcreate-produceJobLimit"></tip>
            </div>
            <zm-input-number size="small" v-model="form.produceJobLimit" :min="0"></zm-input-number>
        </zm-form-item>
        <zm-form-item label="maxRetryTimes">
            <div slot="label">
                <tip label="maxRetryTimes" id="topic-batchcreate-maxRetryTimes"></tip>
            </div>
            <zm-input-number size="small" v-model="form.maxRetryTimes" :min="0"></zm-input-number>
        </zm-form-item>
        <zm-form-item label="retryInterval">
            <div slot="label">
                <tip label="retryInterval" id="topic-batchcreate-retryInterval"></tip>
            </div>
            <div style="width: 100%">
                <zm-input-number size="small" v-model="form.retryInterval"
                    :min="0" class="number-with-select"></zm-input-number>
                <zm-select size="small" v-model="form.retryIntervalTimeUnit"
                    class="select-with-number">
                    <zm-option value="SECONDS">SECONDS</zm-option>
                    <zm-option value="MINUTES">MINUTES</zm-option>
                    <zm-option value="HOURS">HOURS</zm-option>
                    <zm-option value="DAYS">DAYS</zm-option>
                </zm-select>
            </div>
        </zm-form-item>
        <zm-form-item label="ttlDuration">
            <div slot="label">
                <tip label="ttlDuration" id="topic-batchcreate-ttlDuration"></tip>
            </div>
            <div style="width: 100%">
                <zm-input-number size="small" v-model="form.ttlDuration" :min="0" class="number-with-select"></zm-input-number>
                <zm-select size="small" v-model="form.ttlDurationTimeUnit" class="select-with-number">
                        <zm-option value="SECONDS">SECONDS</zm-option>
                        <zm-option value="MINUTES">MINUTES</zm-option>
                        <zm-option value="HOURS">HOURS</zm-option>
                        <zm-option value="DAYS">DAYS</zm-option>
                    </zm-select>
            </div>
        </zm-form-item>
        <zm-form-item label="timeout">
            <div slot="label">
                <tip label="timeout" id="topic-batchcreate-timeout"></tip>
            </div>
            <div style="width: 100%">
                <zm-input-number size="small" v-model="form.timeout" :min="0" class="number-with-select"></zm-input-number>
                <zm-tag type="info" class="tag-with-number">MINUTES</zm-tag>
            </div>
        </zm-form-item>
            </zm-collapse-item>
            <zm-collapse-item title="advanced features" name="1">
            <div v-for="item in advancedFeatureMap" :key="item.display">
                <zm-form-item label-width="175px">
                    <template slot="label">
                        <tip :label="item.display" :tips="item.description"></tip>
                    </template>
                    <zm-radio-group v-model="item.currentValue" v-if="item.frontEndType === 2">
                        <zm-radio v-for="radio in item.suggestedValues" :key="radio" :label="radio">{{ radio }}</zm-radio>
                    </zm-radio-group>
                    <zm-input-number size="small" v-model="item.currentValue" :min="1"
                        v-if="item.frontEndType === 1 && item.display !== 'minInSyncRelicas'"></zm-input-number>
                    <zm-input-number size="small" v-model="item.currentValue" :min="1" :max="form.factor"
                        v-if="item.frontEndType === 1 && item.display === 'minInSyncRelicas'"></zm-input-number>
                    <zm-select size="small" v-model="item.currentValue" v-if="item.frontEndType === 0">
                        <zm-option v-for="radio in item.suggestedValues" :key="radio" :value="radio">{{ radio }}</zm-option>
                    </zm-select>
                </zm-form-item>
            </div>
            </zm-collapse-item>
        </zm-collapse>
    </zm-form>
    <zm-row v-if="active === 1">
        <zm-col :span="8">
            <b>publishers</b>
            <div class="user-list">
            <zm-checkbox-group vertical v-model="editPrivileges.publisherUserIds">
                <zm-checkbox v-for="item in publishers" :key="item.id" :label="item.id"
                :class="item.active?'active-user':'inactive-user'">{{ item.name }}</zm-checkbox>
            </zm-checkbox-group>
            </div>
        </zm-col>
        <zm-col :span="8">
            <zm-input size="small" type="text" class="search-app-input" placeholder="search app" v-model.trim="editPrivileges.search"></zm-input>
            <div class="app-list">
                <div v-for="item in apps" :key="item.id" class="user-privilege" :class="item.active?'active-user':'inactive-user'">
                    <zm-button type="icon" class="zm-icon-left" style="float: left" @click="appendPub(item.id)"
                        :disabled="editPrivileges.publisherUserIds.indexOf(item.id) !== -1"></zm-button>
                    <span>{{ item.name }}</span>
                    <zm-button type="icon" class="zm-icon-right" style="float: right" @click="appendSub(item.id)"
                        :disabled="editPrivileges.subscriberUserIds.indexOf(item.id) !== -1"></zm-button>
                </div>
            </div>
        </zm-col>
        <zm-col :span="8">
            <b>subscribers</b>
            <div class="user-list">
            <zm-checkbox-group vertical v-model="editPrivileges.subscriberUserIds">
                <zm-checkbox v-for="item in subscribers" :key="item.id" :label="item.id"
                :class="item.active?'active-user':'inactive-user'">{{ item.name }}</zm-checkbox>
            </zm-checkbox-group>
            </div>
        </zm-col>
    </zm-row>
    <zm-form v-if="active === 2">
        <div v-for="item in extraInfos" :key="item.key">
            <zm-form-item label-width="100%" required>
                <template slot="label">
                    <tip :label="item.key" :id="'requestTopic-extraInfo-' + item.key"></tip>
                </template>
            </zm-form-item>
            <zm-form-item label-width="0">
                <zm-input type="textarea" size="small" v-model="item.value"></zm-input>
            </zm-form-item>
        </div>
    </zm-form>
    <zm-steps :active="active" finish-status="success">
        <zm-step title="Step 1"></zm-step>
        <zm-step title="Step 2"></zm-step>
        <zm-step title="Step 3"></zm-step>
    </zm-steps>
    <div slot="footer" class="dialog-footer">
        <zm-button size="small" @click="visible = false">Cancel</zm-button>
        <zm-button size="small" type="primary" @click="active--" v-if="active">Previous</zm-button>
        <zm-button size="small" type="primary" @click="active++" v-if="active < 2">Next</zm-button>
        <zm-button size="small" type="primary" @click="save()" :loading="loading" v-if="active === 2">Submit</zm-button>
    </div>
</zm-dialog>
</template>
<script>
import { listClient } from '../../api/clientparam'
import { getTopicConfig, getUsers } from '@/api/index'
import { createRequest, getRequestExtraInfo } from '@/api/request'
import tip from 'components/ToolTip/index'
import batchCreateParam from './batchCreateParam'
export default {
    name: 'createTopics',
    components: {
        batchCreateParam,
        tip
    },
    props: ['isRequestTopic'],
    data () {
        return {
            loading: false,
            visible: false,
            active: 0,
            requestParam: {
                type: 'CREATE_TOPICS'
            },
            form: {
                batchTopicParams: [],
                clusterGroup: '',
                owner: '',
                version: '',
                restartVersion: '',
                clientMapRetentionDay: 7,
                channels: 3,
                factor: 1,
                broadcast: false,
                channelId: '',
                discardUnhandledTask: false,
                disableFailover: false,
                maxProduceRetryTimes: 3,
                produceRetryInterval: 1,
                produceRetryIntervalTimeUnit: 'MINUTES',
                produceLimit: 0,
                produceJobLimit: 0,
                ack: true,
                threshold: 1000,
                pollDurationMs: 5000,
                publishIsPublic: false,
                subscribeIsPublic: false,
                maxRetryTimes: 3,
                retryIntervalTimeUnit: 'MINUTES',
                retryInterval: 1,
                ttlDuration: 7,
                ttlDurationTimeUnit: 'DAYS',
                timeout: 30,
                timeoutIsSuccess: true,
                active: true,
                description: '',
                minchannel: 1,
                minRestartVersion: 1,
                failedRate: 0,
                ordered: false,
                consumerClientParamId: '',
                producerClientParamId: '',
                enableMetrics: true
            },
            extraInfos: [],
            producerClient: [],
            consumerClient: [],
            showAdvancedFeatureMap: [],
            advancedFeatureMap: {},
            editPrivileges: {
                publisherUserIds: [],
                subscriberUserIds: [],
                search: '',
                users: []
            },
            formLabelWidth: '150px',
            rules: {
                // name: [
                //     { required: true, message: 'please enter name', trigger: 'blur' }
                // ],
                owner: [
                    { required: true, message: 'please enter owner', trigger: 'blur' }
                ],
                // dcName: [
                //     { required: true, message: 'please select a dc', trigger: 'change' }
                // ],
                description: [
                    { required: true, message: 'please enter description', trigger: 'blur' }
                ]
            }
        }
    },
    watch: {
        visible () {
            this.form.batchTopicParams = [{
                name: '',
                dcName: '',
                groupName: '',
                jobStore: ''
            }]
        }
    },
    created () {
        getTopicConfig().then(response => {
            this.topicFactor = response.topicFactor
            this.form.factor = response.topicFactor
            this.advancedFeatureMap = response.advancedFeatureMap
            this.refreshTopicConfig()
        })
        this.extraInfos = []
        if (this.isRequestTopic) {
        getRequestExtraInfo('CREATE_TOPICS').then(response => {
            response['CREATE_TOPICS'].map(item => {
                this.extraInfos.push({
                    key: item,
                    value: ''
                })
            })
        })
        }
        this.fetchClient()
        this.getUsers()
        this.editPrivileges.publisherUserIds = []
        this.editPrivileges.subscriberUserIds = []
        this.editPrivileges.search = ''
    },
    computed: {
        apps () {
            if (this.editPrivileges.search) {
                return this.editPrivileges.users.filter(data => {
                    return String(data.name).toLowerCase().indexOf(this.editPrivileges.search) > -1
                })
            }
            return this.editPrivileges.users
        },
        publishers () {
            if (this.editPrivileges.publisherUserIds.length) {
                return this.editPrivileges.users.filter(data => {
                    return this.editPrivileges.publisherUserIds.indexOf(data.id) > -1
                })
            }
            return []
        },
        subscribers () {
            if (this.editPrivileges.subscriberUserIds.length) {
                return this.editPrivileges.users.filter(data => {
                    return this.editPrivileges.subscriberUserIds.indexOf(data.id) > -1
                })
            }
            return []
        }
    },
    methods: {
        addParam () {
            this.form.batchTopicParams.push({
                name: '',
                dcName: '',
                groupName: '',
                jobStore: ''
            })
        },
        refreshTopicConfig () {
            for (var item in this.advancedFeatureMap) {
                if (this.advancedFeatureMap[item].frontEndType === 0) {
                    const suggestedValues = this.advancedFeatureMap[item].suggestedValues
                    if ((typeof suggestedValues) === 'string') {
                        this.advancedFeatureMap[item].suggestedValues = suggestedValues.substring(1, suggestedValues.length - 1).split(',')
                    }
                }
                if (this.advancedFeatureMap[item].frontEndType === 2) {
                    const suggestedValues = this.advancedFeatureMap[item].suggestedValues
                    if ((typeof suggestedValues) === 'string') {
                        this.advancedFeatureMap[item].suggestedValues = JSON.parse(suggestedValues)
                    }
                }
            }
        },
        fetchClient () {
            listClient('PRODUCER').then(response => {
                this.producerClient = response
                this.producerClient.map(item => {
                    if (item.defaultParam) {
                        this.form.producerClientParamId = item.id
                    }
                })
            })
            listClient('CONSUMER').then(response => {
                this.consumerClient = response
                this.consumerClient.map(item => {
                    if (item.defaultParam) {
                        this.form.consumerClientParamId = item.id
                    }
                })
            })
        },
        updateName (val) {
            this.form.batchTopicParams[val.index].name = val.name
        },
        deleteParam (val) {
            if (this.form.batchTopicParams.length > 1) {
                this.form.batchTopicParams.map((item, index) => {
                    item.name = this.$refs['batch-param-' + index][0].form.name
                    item.dcName = this.$refs['batch-param-' + index][0].form.dcName
                    item.groupName = this.$refs['batch-param-' + index][0].form.groupName
                    item.jobStore = this.$refs['batch-param-' + index][0].form.jobStore
                })
                this.form.batchTopicParams.splice(val, 1)
                this.form.batchTopicParams.map((item, index) => {
                    this.$refs['batch-param-' + index][0].form.name = item.name
                    this.$refs['batch-param-' + index][0].form.dcName = item.dcName
                    this.$refs['batch-param-' + index][0].form.groupName = item.groupName
                    this.$refs['batch-param-' + index][0].form.jobStore = item.jobStore
                })
            } else {
                this.form.batchTopicParams[0].name = ''
                this.form.batchTopicParams[0].dcName = ''
                this.form.batchTopicParams[0].groupName = ''
                this.form.batchTopicParams[0].jobStore = ''
                this.$refs['batch-param-0'][0].form.name = ''
                this.$refs['batch-param-0'][0].form.dcName = ''
                this.$refs['batch-param-0'][0].form.groupName = ''
                this.$refs['batch-param-0'][0].form.jobStore = ''
                this.$message.warning('Please input batchTopicParams')
            }
        },
        appendPub (id) {
            this.editPrivileges.publisherUserIds.push(id)
        },
        appendSub (id) {
            this.editPrivileges.subscriberUserIds.push(id)
        },
        getUsers () {
            getUsers().then(response => {
                this.editPrivileges.users = response
            })
        },
        save () {
            var extraValid = true
            var extraInfos = {}
            this.extraInfos.map(item => {
                extraInfos[item.key] = item.value
                if (item.value === '') {
                    extraValid = false
                }
            })
            this.$refs.form.validate((valid) => {
                var batchTopicParamsValid = true
                this.form.batchTopicParams.map((item, index) => {
                    item.name = this.$refs['batch-param-' + index][0].form.name
                    item.dcName = this.$refs['batch-param-' + index][0].form.dcName
                    item.groupName = this.$refs['batch-param-' + index][0].form.groupName
                    item.jobStore = this.$refs['batch-param-' + index][0].form.jobStore
                    if (!item.name || !item.dcName || !item.groupName) {
                        this.$message.error('Please check batchTopicParams!')
                        batchTopicParamsValid = false
                    }
                })
                if (valid && batchTopicParamsValid && extraValid) {
                    this.loading = true
                    var { batchTopicParams,
                        owner,
                        version,
                        restartVersion,
                        clientMapRetentionDay,
                        channels,
                        factor,
                        channelId,
                        discardUnhandledTask,
                        disableFailover,
                        maxProduceRetryTimes,
                        produceRetryInterval,
                        produceRetryIntervalTimeUnit,
                        produceLimit,
                        produceJobLimit,
                        ack,
                        broadcast,
                        threshold,
                        pollDurationMs,
                        publishIsPublic,
                        subscribeIsPublic,
                        enableMetrics,
                        maxRetryTimes,
                        retryIntervalTimeUnit,
                        retryInterval,
                        ttlDuration,
                        ttlDurationTimeUnit,
                        timeout,
                        timeoutIsSuccess,
                        active,
                        failedRate,
                        ordered,
                        consumerClientParamId,
                        producerClientParamId,
                        description } = this.form
                    var advancedFeatureMapStr = JSON.stringify(this.advancedFeatureMap)
                    var advancedFeatureMap = JSON.parse(advancedFeatureMapStr)
                    for (var item in advancedFeatureMap) {
                        let suggestedValues = JSON.stringify(advancedFeatureMap[item].suggestedValues)
                        // eslint-disable-next-line
                        advancedFeatureMap[item].suggestedValues = suggestedValues.replace(/(\")/g, '')
                    }
                    const { subscriberUserIds, publisherUserIds } = this.editPrivileges
                    const data = { batchTopicParams,
                        advancedFeatureMap,
                        owner,
                        version,
                        restartVersion,
                        clientMapRetentionDay,
                        channels,
                        factor,
                        channelId,
                        discardUnhandledTask,
                        disableFailover,
                        maxProduceRetryTimes,
                        produceRetryInterval,
                        produceRetryIntervalTimeUnit,
                        produceLimit,
                        produceJobLimit,
                        ack,
                        broadcast,
                        threshold,
                        pollDurationMs,
                        publishIsPublic,
                        subscribeIsPublic,
                        enableMetrics,
                        maxRetryTimes,
                        retryIntervalTimeUnit,
                        retryInterval,
                        ttlDuration,
                        ttlDurationTimeUnit,
                        timeout,
                        timeoutIsSuccess,
                        active,
                        failedRate,
                        ordered,
                        consumerClientParamId,
                        producerClientParamId,
                        description,
                        subscriberUserIds,
                        publisherUserIds }
                    this.requestParam.params = data
                    this.requestParam.extraInfos = extraInfos
                    createRequest(this.requestParam).then(response => {
                        this.$message({
                            message: 'Create request success!',
                            type: 'success'
                        })
                        this.visible = false
                        this.$emit('refreshRequest')
                        this.$refs.form.resetFields()
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        }
    }
}
</script>
<style>
.zm-tabs--top, .zm-tabs--bottom {
    border-bottom: solid 2px #F2F2F7;
    margin-bottom: 10px;
}
.zm-tabs--card > .zm-tabs__header .zm-tabs__item {
    font-size: 14px;
    line-height: 20px;
    padding: 2px 5px;
}
</style>
<style scoped>
.user-list {
    height: 40vh;
    overflow-y: auto;
    margin: 22px 10px 0 0;
}
.app-list {
    height: 40vh;
    overflow-y: auto;
    margin: 10px 10px 0 10px;
}
.inactive-user {
    background-color: #fce9e9;
}
.active-user {
    background-color: #e0fbd39e;
}
.user-privilege {
    display: inline-block;
    text-align: center;
    width: 100%;
}
.search-app-input {
    width: 80%;
    margin: 0 10px;
}
</style>
